import { SecretSchema } from "../../../../config/types";

type GetValue = (name: string) => string | undefined;

// Whether to skip the secrets form: only when every field, optional ones included,
// already has a value. An optional field the backend left on the form still needs
// a chance to be filled in.
export const areAllSecretsFilled = (secrets: SecretSchema[], getValue: GetValue) =>
  secrets.every(secret => !!getValue(secret.name));

// Whether the user can leave the secrets form for OAuth: a blank optional field
// does not block.
export const areRequiredSecretsFilled = (secrets: SecretSchema[], getValue: GetValue) =>
  secrets.every(secret => secret.optional === true || !!getValue(secret.name));
